@if (isVisible()) {
  <!-- Not on a nudge: it is one step with its own Later button, and "Skip tour" would offer to
       dismiss a tutorial that is not running. -->
  @if (onboardingMode() && !isWelcome() && !onboarding.isNudge()) {
    <button class="mb-skip-tour-pill" [class.mb-leaving]="leaving()" (click)="skipTour()">Skip tour</button>
  }

  @if (showOverlay()) {
    <div class="mb-click-blocker" [style.clip-path]="blockerClipPath()"></div>

    @if (activeSpotlight(); as s) {
      <div
        class="mb-spotlight-hole"
        [style.top.px]="s.top"
        [style.left.px]="s.left"
        [style.width.px]="s.width"
        [style.height.px]="s.height"
        [style.border-radius]="s.borderRadius"></div>

      <div
        class="mb-spotlight-ring"
        [style.top.px]="s.top"
        [style.left.px]="s.left"
        [style.width.px]="s.width"
        [style.height.px]="s.height"
        [style.border-radius]="s.borderRadius"></div>

      <!-- Not on a nudge: the hand is the attention cue there, and a pulsing control underneath it
           reads as two things asking at once. -->
      @if (!onboarding.isNudge()) {
        <div
          class="mb-spotlight-pulse"
          [style.top.px]="s.top"
          [style.left.px]="s.left"
          [style.width.px]="s.width"
          [style.height.px]="s.height"
          [style.border-radius]="s.borderRadius"></div>
      }

      @if (onboardingMode() && !onboarding.isNudge()) {
        <div
          class="mb-spotlight-interceptor"
          role="button"
          tabindex="0"
          [style.top.px]="s.top"
          [style.left.px]="s.left"
          [style.width.px]="s.width"
          [style.height.px]="s.height"
          [style.border-radius]="s.borderRadius"
          (click)="onInterceptorClick()"
          (keydown.enter)="onInterceptorClick()"></div>
      }

      @if (showCursorIndicator()) {
        <div
          class="mb-cursor-indicator"
          [class.mb-cursor-lg]="onboarding.isNudge()"
          [class.mb-cursor-hidden]="cursorHidden()"
          [style.top.px]="cursorPosition()?.top"
          [style.left.px]="cursorPosition()?.left">
          <span class="material-icons mb-cursor-icon">touch_app</span>
          @if (!onboarding.isNudge()) {
            <span class="mb-cursor-label">click</span>
          }
        </div>
      }
    }

    @if (!activeSpotlight()) {
      <div class="mb-overlay-solid" [class.mb-leaving]="leaving()"></div>
    }
  }

  <div
    class="mb-stage"
    [class.mb-leaving]="leaving()"
    [class.ob-stage]="onboardingMode()"
    [class.mb-anchored]="!onboardingMode() && activeSpotlight()?.anchorTop"
    [style.top.px]="!onboardingMode() ? activeSpotlight()?.anchorTop : null"
    [style.left.px]="!onboardingMode() ? activeSpotlight()?.anchorLeft : null">
    <div class="mb-mascot-wrap">
      <img [ngSrc]="mascotImage()" alt="Knowzilla" [width]="mascotSize()" [height]="mascotSize()" class="mb-mascot" priority />
    </div>

    <div class="mb-right">
      <div class="mb-bubble-wrap" [style.max-width]="bubbleMaxWidth()">
        <div class="mb-bubble-tail"></div>
        <div class="mb-bubble">
          <p class="mb-bubble-text" [innerHTML]="displayMessage()"></p>
        </div>
      </div>

      @if (displayResponses().length > 0) {
        <div class="mb-responses">
          @for (resp of displayResponses(); track resp.id) {
            <button [class]="resp.primary ? 'mb-btn-primary' : 'mb-btn-secondary'" (click)="onMascotResponseClick(resp.id)">
              {{ resp.label }}
              @if (resp.arrow) {
                <span class="mb-arrow">→</span>
              }
            </button>
          }
        </div>
      }

      @if (displayHint()) {
        <p class="mb-hint">{{ displayHint() }}</p>
      }
    </div>
  </div>
}
